import { c as _c } from "react/compiler-runtime";
import { SvgChevronright } from '@common/icon';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { DaysLeft } from './DaysLeft';
import { ProgressBar } from './ProgressBar';
interface ProjectCardProps {
  title: string;
  thumbnailUrl: string;
  businessId: number;
  /** 남은 날자수 */
  daysLeft: number;
  donationAmount: number;
  achievementRate: number;
  institution?: {
    id: number;
    logoUrl: string;
    name: string;
  };
  isEnded?: boolean;
  onProjectLinkClick?: () => void;
}
export const ProjectCard = t0 => {
  const $ = _c(45);
  const {
    title,
    thumbnailUrl,
    businessId,
    daysLeft,
    donationAmount,
    achievementRate,
    institution,
    isEnded,
    onProjectLinkClick
  } = t0;
  let t1;
  if ($[0] !== businessId) {
    t1 = DONATION_ROUTES.HOMETOWN_BUSINESS_DETAIL.pathname({
      id: businessId
    });
    $[0] = businessId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== thumbnailUrl || $[3] !== title) {
    t2 = <Image fill={true} sizes={`${BREAKPOINTS.MOBILE} 100vw, ${BREAKPOINTS.TABLET} 50vw, 314px`} src={thumbnailUrl} alt={title} className="object-cover" />;
    $[2] = thumbnailUrl;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onProjectLinkClick || $[6] !== t1 || $[7] !== t2) {
    t3 = <CustomLink href={t1} aria-label={"\uC9C0\uC815\uAE30\uBD80\uC0AC\uC5C5 \uC0C1\uC138 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} onClick={onProjectLinkClick} className="relative block aspect-[335/180] w-full">{t2}</CustomLink>;
    $[5] = onProjectLinkClick;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = !institution;
  let t5;
  if ($[9] !== t4) {
    t5 = cn("mb-8 flex items-center justify-between", {
      "justify-end": t4
    });
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== institution) {
    t6 = institution ? <CustomLink href={DONATION_ROUTES.HOMETOWNS_DETAIL.withSearchParams({
      dynamicPath: {
        id: institution.id
      },
      searchParams: {
        tab: "projects"
      }
    })} aria-label={"\uC9C0\uC790\uCCB4 \uC0C1\uC138 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} className="flex items-center gap-4"><Image className="size-20 rounded-pill border border-Gray-300" src={institution.logoUrl} alt={institution.name} width={20} height={20} /><span className="mt-1 font-600 text-Gray-600 typo-caption1">{institution.name}</span><SvgChevronright className="size-12 text-Gray-600" /></CustomLink> : null;
    $[11] = institution;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== daysLeft || $[14] !== isEnded) {
    t7 = <DaysLeft value={daysLeft} isEnded={isEnded} />;
    $[13] = daysLeft;
    $[14] = isEnded;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== businessId) {
    t9 = DONATION_ROUTES.HOMETOWN_BUSINESS_DETAIL.pathname({
      id: businessId
    });
    $[20] = businessId;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== onProjectLinkClick || $[23] !== t9 || $[24] !== title) {
    t10 = <CustomLink href={t9} aria-label={"\uC9C0\uC815\uAE30\uBD80\uC0AC\uC5C5 \uC0C1\uC138 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} className="mb-16 line-clamp-2 w-fit overflow-hidden text-ellipsis font-600 text-Gray-black typo-body3" onClick={onProjectLinkClick}>{title}</CustomLink>;
    $[22] = onProjectLinkClick;
    $[23] = t9;
    $[24] = title;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== achievementRate) {
    t11 = <ProgressBar progress={achievementRate} />;
    $[26] = achievementRate;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== achievementRate) {
    t12 = <span className="text-R-500">{achievementRate}%</span>;
    $[28] = achievementRate;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== donationAmount) {
    t13 = donationAmount.toLocaleString();
    $[30] = donationAmount;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t13) {
    t14 = <span className="text-Gray-black">{t13} 원</span>;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t12 || $[35] !== t14) {
    t15 = <div className="mt-10 flex h-30 items-center justify-between gap-2 font-700 typo-body3">{t12}{t14}</div>;
    $[34] = t12;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t15 || $[40] !== t8) {
    t16 = <div className="px-20 py-16">{t8}{t10}{t11}{t15}</div>;
    $[37] = t10;
    $[38] = t11;
    $[39] = t15;
    $[40] = t8;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== t16 || $[43] !== t3) {
    t17 = <article className="overflow-hidden rounded-xlarge border border-Gray-300">{t3}{t16}</article>;
    $[42] = t16;
    $[43] = t3;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  return t17;
};